import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    cardCustomPadding: {
      padding: '16px 20px 5px 32px',
    },

    cardContentPadding: {
      padding: '20px 32px 32px',
    },

    menuButton: {
      textTransform: 'capitalize',
      padding: 0,
    },

    statusIcon: {
      color: theme.palette.secondary.dark,
      marginLeft: 5,
    },

    prioritiesIcon: {
      color: theme.palette.secondary.light,
      marginLeft: 5,
    },

    textSecondary: {
      color: theme.palette.secondary.dark,
    },

    addButton: {
      fontSize: 13,
      padding: 0,
      marginRight: 15,
      textTransform: 'capitalize',
      marginLeft: '2rem',
    },

    tagsContainer: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
    },

    tag: {
      margin: theme.spacing(0.5),
    },

    tagsItem: {
      backgroundColor: '#EEEEEE',
      borderRadius: 10,
      marginBottom: 13,
      marginRight: 16,
      padding: '5px 14px',
    },
    loadingContainer: {
      height: 150,
      width: '100%',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
    padding: '14px 34px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 16px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, customCardStyles, collapseCardStyles };
